import { AlphaMCircleIcon } from './AlphaMCircleIcon';

/**
 * author: Contributors
 * id 88D09175-8E63-4542-BBE7-6B8D7EC16EBE
 * name alpha-m-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-m-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetMCircleIcon = AlphaMCircleIcon;
export default AlphabetMCircleIcon